import { api, ApiError, type User } from "../api.js";
import { el } from "../render/svg.js";

/** Mostra la schermata di login e risolve con l'utente autenticato. */
export function showLogin(root: HTMLElement): Promise<User> {
  return new Promise((resolve) => {
    root.innerHTML = "";
    const card = el("form", "login-card") as HTMLFormElement;
    card.appendChild(el("h1", "login-title", "Fullsteps"));
    card.appendChild(el("p", "login-sub", "Accedi per visualizzare e modificare i diagrammi."));

    const email = el("input") as HTMLInputElement;
    email.type = "email";
    email.placeholder = "email";
    email.autocomplete = "username";
    email.required = true;
    const pass = el("input") as HTMLInputElement;
    pass.type = "password";
    pass.placeholder = "password";
    pass.autocomplete = "current-password";
    pass.required = true;
    const err = el("p", "login-err");
    err.hidden = true;
    const btn = el("button", undefined, "Entra") as HTMLButtonElement;
    btn.type = "submit";
    card.append(email, pass, err, btn);

    card.addEventListener("submit", async (e) => {
      e.preventDefault();
      err.hidden = true;
      btn.disabled = true;
      btn.textContent = "…";
      try {
        resolve(await api.login(email.value.trim(), pass.value));
      } catch (ex) {
        err.textContent = ex instanceof ApiError ? ex.message : "errore di rete";
        err.hidden = false;
        btn.disabled = false;
        btn.textContent = "Entra";
      }
    });

    const wrap = el("div", "login-wrap");
    wrap.appendChild(card);
    root.appendChild(wrap);
    email.focus();
  });
}
